import Blockly from 'blockly'
import 'blockly/python'
import blocklyUtil from '../blocklyUtil'

let blockJson = {
  type: 'machine_ifcontrol',
  message0: '%{BKY_CUSTOM_MACHINE_IFCONTROL}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/JvHm1np/gamepad-solid.png',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'field_dropdown',
      name: 'BUTTON',
      options: [
        ['Y', 'Y'],
        ['X', 'X'],
        ['B', 'B'],
        ['A', 'A'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_ALL_BUTTONS}', 'BUTTONS'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_UP}', 'UP'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_DOWN}', 'DOWN'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_LEFT}', 'LEFT'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_RIGHT}', 'RIGHT'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_ALL_ARROWS}', 'ARROWS']
      ]
    },
    {
      type: 'input_dummy'
    },
    {
      type: 'field_dropdown',
      name: 'ACTION',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_PRESSED}', 'setKeyDownCallback'],
        ['%{BKY_CUSTOM_MACHINE_IFCONTROL_V_RELEASED}', 'setKeyUpCallback']
      ]
    },
    {
      type: 'input_dummy'
    },
    {
      type: 'input_statement',
      name: 'STATEMENTS'
    }
  ],
  inputsInline: true,
  style: 'start_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFCONTROL_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifcontrol'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifcontrol'] = function (block) {
  let index = _.indexOf(ifcontrolBlocks, block.id)
  if (index < 0) {
    ifcontrolBlocks.push(block.id)
    index = _.indexOf(ifcontrolBlocks, block.id)
  }
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifcontrol = 'import _ic'
  let dropdownButton = block.getFieldValue('BUTTON')
  let dropdownAction = block.getFieldValue('ACTION')
  let statementsCallback = Blockly.Python.statementToCode(block, 'STATEMENTS')
  // statementsCallback = statementsCallback.replace(
  //   /ifline\.(front|back)\(([0-9.]*)\)/gi,
  //   `ifline.$1($2, False)`
  // )
  let functionName = `${dropdownButton}${
    dropdownAction === 'setKeyDownCallback' ? 'keyDown' : 'keyUp'
  }${index + 1}`
  let code = `def ${functionName}():
${blocklyUtil.getVariables(block)}${statementsCallback}\n
_ic.${dropdownAction}('${dropdownButton}', ${functionName})\n\n`
  _.set(Blockly.Python.definitions_, `ifcontrolCode${index + 1}`, code)
  return ''
}

let ifcontrolBlocks = []
